import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="footer-logo" onClick={toTop}>
                <h2>tugglefield</h2>
              </Link>
              <p className="footer-description">
                Thoughtful teas and coffees, selected for clarity, character,
                and a more rewarding daily ritual.
              </p>
            </div>

            <div className="footer-links-section">
              <h3>Shop</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/shop" onClick={toTop}>
                    All Products
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-links-section">
              <h3>Company</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/about" onClick={toTop}>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={toTop}>
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/shipping" onClick={toTop}>
                    Shipping
                  </Link>
                </li>
                <li>
                  <Link to="/returns" onClick={toTop}>
                    Returns
                  </Link>
                </li>
                <li>
                  <Link to="/policies" onClick={toTop}>
                    Policy Center
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-links-section">
              <h3>Policies</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/privacy" onClick={toTop}>
                    Privacy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" onClick={toTop}>
                    Terms
                  </Link>
                </li>
                <li>
                  <Link to="/payments" onClick={toTop}>
                    Payment &amp; Billing
                  </Link>
                </li>
                <li>
                  <Link to="/orders" onClick={toTop}>
                    Orders &amp; Cancellations
                  </Link>
                </li>
                <li>
                  <Link to="/shipping" onClick={toTop}>
                    Shipping
                  </Link>
                </li>
                <li>
                  <Link to="/returns" onClick={toTop}>
                    Returns &amp; Refunds
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-links-section">
              <h3>Connect</h3>
              <p className="newsletter-description">
                <a href="mailto:steps@tugglefield.xyz">steps@tugglefield.xyz</a>
                <br />
                WHAMPOA ESTATE, 27B TAK MAN STREET, KOWLOON CITY DISTRICT,
                KOWLOON
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {new Date().getFullYear()} tugglefield. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy" onClick={toTop}>
                Privacy Policy
              </Link>
              <Link to="/terms" onClick={toTop}>
                Terms of Service
              </Link>
              <Link to="/faqs" onClick={toTop}>
                FAQs
              </Link>
              <Link to="/cookies" onClick={toTop}>
                Cookie Policy
              </Link>
              <Link to="/accessibility" onClick={toTop}>
                Accessibility
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
